var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2236 11.9472L16.9642 7.42848C16.5835 6.667 15.486 6.69925 15.1507 7.48178L13.2597 11.8939C13.1022 12.2616 12.7406 12.5 12.3406 12.5H8.08661C7.17257 12.5 6.73761 13.6251 7.41393 14.2399L10.5345 17.0768C10.819 17.3355 10.93 17.7344 10.8201 18.1028L9.27836 23.2675C9.01219 24.1592 10.0014 24.8991 10.7816 24.392L15.4722 21.3431C15.7948 21.1334 16.209 21.1274 16.5376 21.3276L21.5842 24.4029C22.3893 24.8935 23.3639 24.0993 23.046 23.2117L21.2357 18.158C21.0941 17.7628 21.2145 17.3213 21.5369 17.0526L24.8781 14.2682C25.5966 13.6695 25.1732 12.5 24.238 12.5H20.118C19.7393 12.5 19.393 12.286 19.2236 11.9472Z",
    stroke: "#0BC196",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.abcf5f43a96357bb5a5a7115eaf59f55.svg";
export { ForwardRef as ReactComponent };